import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { WelcomeTour } from "./WelcomeTour";

export function ApplicantOnboarding() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showTour, setShowTour] = useState(false);

  useEffect(() => {
    // Only show tour if user is on the applicant portal routes
    const isOnApplicantPortal = location.pathname.startsWith('/portal');
    const hasSeenApplicantTour = localStorage.getItem("hasSeenApplicantTour");
    
    if (isOnApplicantPortal && !hasSeenApplicantTour) {
      setShowTour(true);
    } else {
      setShowTour(false);
    }
  }, [location.pathname]);

  const steps = [
    {
      title: "Welcome to Your Applicant Portal",
      description: "Track your application status, upload documents, and communicate with the admissions team all in one place.",
    },
    {
      title: "Track Your Application",
      description: "See your current application status and what steps are needed next. You'll receive notifications for any updates.",
      action: {
        label: "View Dashboard",
        onClick: () => {
          navigate("/portal");
          setShowTour(false);
        },
      },
    },
    {
      title: "Upload Documents",
      description: "Submit required documents like transcripts, recommendations, and identification. Track verification status in real-time.",
      action: {
        label: "Upload Documents",
        onClick: () => {
          navigate("/portal/documents");
          setShowTour(false);
        },
      },
    },
    {
      title: "Stay Connected",
      description: "Use the Messages tab to communicate directly with admissions staff. Check your notifications regularly for updates.",
    },
    {
      title: "Ready to Begin!",
      description: "Complete your application, upload required documents, and track your progress. We're here to help if you need anything!",
    },
  ];

  const handleComplete = () => {
    localStorage.setItem("hasSeenApplicantTour", "true");
    setShowTour(false);
  };

  if (!showTour) return null;

  return <WelcomeTour steps={steps} onComplete={handleComplete} />;
}
